import { render, staticRenderFns } from "./formComponent.vue?vue&type=template&id=623dd02c&scoped=true&"
import script from "./formComponent.vue?vue&type=script&lang=js&"
export * from "./formComponent.vue?vue&type=script&lang=js&"
import style0 from "./formComponent.vue?vue&type=style&index=0&id=623dd02c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623dd02c",
  null
  
)

export default component.exports